<template>
  <el-card>
    <el-form label-width="100px" label-position="right">
      <el-form-item label="所属项目" prop="projectId">
        {{ formData.projectName }}
      </el-form-item>
      <el-form-item label="出库仓库" prop="warehouseId">
        {{ formData.warehouseName }}
      </el-form-item>
      <el-form-item label="出库日期" prop="checkoutDate">
        {{ formData.checkoutDate }}
      </el-form-item>
      <el-form-item label="领用人" prop="checkoutUser">
        {{ formData.checkoutUserName }}
      </el-form-item>
      <el-form-item label="出库说明" prop="checkoutExplain">
        {{ formData.checkoutExplain }}
      </el-form-item>
      <el-form-item label="出库物料明细" prop="detailedList">
      </el-form-item>
      <el-table class="global-table material-table" :data="formData.detailedList">
        <el-table-column prop="materialTypeName" label="物料分类" show-overflow-tooltip></el-table-column>
        <el-table-column prop="materialName" label="物料名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="specifications" label="规格型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="brand" label="品牌名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="supplierName" label="供应商名称" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ctime" label="入库日期" width="160"></el-table-column>
        <el-table-column prop="afterStock" label="剩余库存" show-overflow-tooltip></el-table-column>
        <el-table-column label="单价" prop="unitPrice"></el-table-column>
        <el-table-column label="单位" prop="company"></el-table-column>
        <el-table-column label="出库类型" prop="checkoutType" show-overflow-tooltip></el-table-column>
        <el-table-column label="出库数量" prop="operationStock" show-overflow-tooltip></el-table-column>
        <el-table-column label="用途说明" prop="bak" show-overflow-tooltip></el-table-column>
      </el-table>
      <div class="imgList" >
        <span>出库图片</span>
        <div v-if="formData?.imgList?.length" class="ListBox">
          <div class="imgItem" v-for="(item, key) in formData.imgList" :key="key">
            <el-image
              :src="item.filePrefix + item.fileUrl"
              :preview-src-list="formData.imgList | previewList"
              fit="fill">
            </el-image>
          </div>
        </div>
        <div v-else>--</div>
      </div>
      <el-form-item label="出库文件">
        <span v-if="formData?.fileList?.length" style="color:blue;cursor: pointer;" @click="onDownload">{{ formData?.fileList[0]?.fileName }}</span>
        <span v-else >--</span>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  name: 'ExwarehouseDetail',
  components: {
  },
  filters: {
    previewList: function (value) {
      return value.map((item) => {
        return item.filePrefix + item.fileUrl
      })
    }
  },
  data () {
    return {
      formData: {
        projectId: '',
        warehouseId: '',
        projectName: '',
        warehouseName: '',
        checkoutDate: '',
        checkoutUser: '',
        checkoutUserName: '',
        checkoutExplain: '',
        detailedList: []
      }
    }
  },
  computed: {
    id () {
      return this.$route.query.id
    }
  },
  watch: {
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$axios.get(this.$apis.material.selectYhCheckoutById, {
        id: this.id
      }).then(res => {
        this.formData = res
      })
    },
    // 下载
    onDownload () {
      const row = this.formData.fileList
      window.location.href = `${row[0].filePrefix + row[0].fileUrl}?attname=${row[0].fileName}`
    }
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/scss/color";
  .imgList{
    display: flex;
    margin: 20px 0;
    span{
      display: inline-block;
      width: 100px;
      text-align: right;
      font-size: 14px;
      padding-right: 12px;
    }
    .ListBox{
      flex: 1;
      display: flex;
      flex-wrap:wrap;
      .imgItem{
        width: 102px;
        height: 102px;
        margin:  0 10px 10px 0;
        .el-image,img,video{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
